/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_UnavailableInputs */

const en_us2_clubs_unavailable = /** @type {(inputs: Clubs_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to see your clubs.`)
};

const pt_br2_clubs_unavailable = /** @type {(inputs: Clubs_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver seus clubes.`)
};

const es_419_clubs_unavailable = /** @type {(inputs: Clubs_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctate a internet para ver tus clubes.`)
};

const pt_pt2_clubs_unavailable = /** @type {(inputs: Clubs_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liga-te à internet para ver os teus clubes.`)
};

const fr_fr2_clubs_unavailable = /** @type {(inputs: Clubs_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecte-toi à Internet pour voir tes clubs.`)
};

const de_de2_clubs_unavailable = /** @type {(inputs: Clubs_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde dich mit dem Internet, um deine Clubs zu sehen.`)
};

const it_it2_clubs_unavailable = /** @type {(inputs: Clubs_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connettiti a internet per vedere i tuoi club.`)
};

/**
* | output |
* | --- |
* | "Connect to the internet to see your clubs." |
*
* @param {Clubs_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_unavailable = /** @type {((inputs?: Clubs_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_unavailable(inputs)
	if (locale === "es-419") return es_419_clubs_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_unavailable(inputs)
	if (locale === "de-DE") return de_de2_clubs_unavailable(inputs)
	if (locale === "it-IT") return it_it2_clubs_unavailable(inputs)
	return en_us2_clubs_unavailable(inputs)
});
export { clubs_unavailable as "clubs.unavailable" }